import { render, staticRenderFns } from "./DocumentDialogSelector.vue?vue&type=template&id=4e9b73a6&scoped=true&"
import script from "./DocumentDialogSelector.vue?vue&type=script&lang=ts&"
export * from "./DocumentDialogSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9b73a6",
  null
  
)

export default component.exports